import './index.scss';
import logo  from '../../assets/logo.png'
export default function Header(props) {
    return <div className="myHeader">
        <img src={logo} className="logo"></img>
        <div className='title'>帮助中心</div>
    </div>
}